import { BUTTON, SELECT, SWITCH, TEXT, COUNTER } from "../../components/Common/Const";

export const IccRankingsFields = [
    {
        name: "matchTypeId",
        label:"Match Type",
        type: SELECT,
        options: [],
        isRequired: true,
        requiredErrorMessage: "Please select Match Type.",
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 }
    },
    {
        name: "sportId",
        label: "Sport",
        isRequired: true,
        requiredErrorMessage: "Please select Sport",
        type: SELECT,
        options: [],
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
    },
    {
        name: "type",
        label: "Type",
        isRequired: true,
        requiredErrorMessage: "Please select Type",
        type: SELECT,
        options: [
            { label: "Select Type", value: "0" },
            { label: "Team", value: 1 },
            { label: "Player", value: 2 },
        ],
        defaultValue: "0",
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
    },
    {
        name: "isMen",
        label: "Men",
        type: SWITCH,
        defaultValue: true,
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 }
    },
    {
        name: "teamId",
        label: "Team",
        isRequired: true,
        requiredErrorMessage: "Please select team",
        type: SELECT,
        options: [],
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
    },
    {
        name: "playerId",
        label: "Player",
        isRequired: true,
        dependsOnField: "type",
        dependsOnValue: 2,
        // requiredWhenField: "type",
        // requiredWhenValue: 2,
        requiredErrorMessage: "Please select player",
        type: SELECT,
        options: [],
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
    },
    {
        name: "playerTypeId",
        label: "Player Type",
        isRequired: true,
        dependsOnField: "type",
        dependsOnValue: 2,
        requiredErrorMessage: "Please select player type",
        type: SELECT,
        options: [
            { label: "Select Player Type", value: "0" },
            { label: "Batsman", value: 1 },
            { label: "Bowler", value: 2 },
            { label: "AllRounder", value: 4 },
        ],
        defaultValue: "0",
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
    },
    {
        name: "point",
        label: "Point",
        // isRequired: true,
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
        type: COUNTER,
    },
    {
        name: "rank",
        label: "Rank",
        parentclassName: "",
        isRequired: true,
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
        type: COUNTER,
    },
    {
        name: "preRank",
        label: "pre.Rank",
        parentclassName: "",
        // isRequired: true,
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
        type: COUNTER,
    },
    {
        name: "rating",
        label: "Rating",
        isRequired: true,
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
        type: TEXT,
    },
    {
        name: "remark",
        label: "Remark",
        // isRequired: true,
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
        type: TEXT,
    },
    // {
    //     name: "generate",
    //     type: BUTTON,
    //     btnLable:"Update",
    //     labelColspan: { xs: 12, md: 2, lg: 2 },
    //     fieldColspan: { xs: 12, md: 2, lg: 2 }
    // },
    {
        name: "isActive",
        label: "Active",
        type: SWITCH,
        defaultValue: true,
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 }
    },
];